import React from 'react';
import {
  List,
  Datagrid,
  DateField,
  ReferenceField,
  TextField,
} from 'react-admin';
import FullNameField from '../General/FullNameField';


export default props => (
  <List
    {...props}
    title="Push Notification Registrations"
    bulkActionButtons={false}
    sort={{ field: 'createdAt', order: 'DESC' }}
  >
    <Datagrid>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
      <DateField source="lastSendOkAt" />
      <DateField source="lastSendErrorAt" />
      <TextField label="OS" source="os" />
      <ReferenceField allowEmpty label="User" source="userId" reference="users" linkType="show" sortable={false}>
        <FullNameField />
      </ReferenceField>
    </Datagrid>
  </List>
);




// WEBPACK FOOTER //
// ./src/components/PushNotificationRegistration/List.js